import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { logger as E } from "../../shared-lib/index.js";
import { getErrorMessage as si } from "./error-utils.js";
import { decodeBrazeActions as uo } from "./string-utils.js";
import { BRAZE_ACTION_URI_REGEX as to, isValidBrazeActionType as co, isValidBrazeActionJson as io } from "./validation-utils.js";
export var BRAZE_ACTIONS = {
  types: {
    io: "container",
    logCustomEvent: "logCustomEvent",
    setEmailNotificationSubscriptionType: "setEmailNotificationSubscriptionType",
    setPushNotificationSubscriptionType: "setPushNotificationSubscriptionType",
    setCustomUserAttribute: "setCustomUserAttribute",
    requestPushPermission: "requestPushPermission",
    addToSubscriptionGroup: "addToSubscriptionGroup",
    removeFromSubscriptionGroup: "removeFromSubscriptionGroup",
    addToCustomAttributeArray: "addToCustomAttributeArray",
    removeFromCustomAttributeArray: "removeFromCustomAttributeArray",
    mo: "openLink",
    uo: "openLinkInWebView"
  },
  properties: {
    type: "type",
    eo: "steps",
    so: "args"
  }
};
export var INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES = {
  Li: "unknownBrazeAction",
  Ac: "noPushPrompt"
};
export var ineligibleBrazeActionURLErrorMessage = function ineligibleBrazeActionURLErrorMessage(t, o) {
  return t === INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Li ? "".concat(o, " contains an unknown braze action type and will not be displayed.") : "";
};
export function getDecodedBrazeAction(t) {
  try {
    var o = t.match(to),
      r = o ? o[0].length : null,
      n = r ? t.substring(r) : null;
    if (null == r || r > t.length - 1 || !n) return void E.error("Did not find base64 encoded brazeAction in url to process : ".concat(t));
    var e = uo(n);
    return e ? JSON.parse(e) : void E.error("Failed to decode base64 encoded brazeAction: ".concat(n));
  } catch (o) {
    return void E.error("Failed to process brazeAction URL ".concat(t, " : ").concat(si(o)));
  }
}
function po(t, o) {
  var r = !1;
  if (o) {
    var _iterator = _createForOfIteratorHelper(o),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        if (r = r || t(n), r) return !0;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return !1;
}
export function containsUnknownBrazeAction(t) {
  var o = BRAZE_ACTIONS.properties.type,
    r = BRAZE_ACTIONS.properties.eo;
  try {
    if (null == t) return !0;
    var n = t[o];
    return n === BRAZE_ACTIONS.types.io ? po(containsUnknownBrazeAction, t[r]) : !co(n);
  } catch (t) {
    return !0;
  }
}
export function containsPushPrimerBrazeAction(t) {
  if (!t || !io(t)) return !1;
  var o = BRAZE_ACTIONS.properties.type,
    r = BRAZE_ACTIONS.properties.eo,
    n = t[o];
  return n === BRAZE_ACTIONS.types.io ? po(containsPushPrimerBrazeAction, t[r]) : n === BRAZE_ACTIONS.types.requestPushPermission;
}